<template>
    <div style="padding:20px">
        <div >
            <a-input v-model:value="queryParam.queryTxt" style="width:300px" placeholder="请输入名称 / 账号" />
            <a-select placeholder="店铺类型"
            v-model:value="queryParam.type" allowClear
            style="width: 120px;margin-left: 20px;"
            >
                
                <a-select-option :value="1">淘宝</a-select-option>
                <a-select-option :value="2">京东</a-select-option>
                <a-select-option :value="3">拼多多</a-select-option>
                <a-select-option :value="5">阿里巴巴</a-select-option>
                <a-select-option :value="6">抖音</a-select-option>
            </a-select>
            <a-button :loading="loading" @click="query(1)" style="float:right;margin-right:20px" type="primary">
                <template #icon><SearchOutlined /></template>
                搜索
            </a-button>
        </div>
        <div style="margin-top:20px">
            <a-table :loading="loading"  :scroll="{ y: tableHeight }"  @change="handleTableChange" :pagination="pagination" :dataSource="list" :columns="columns" >
                <template #bodyCell="{ column, text ,record}">
                    <template v-if="column.key === 'repurchase'">
                        <a-tag color="processing">{{text}}</a-tag>

                    </template>
                    <template v-else-if="column.key === 'praiseDay'" >
                        <a-tag color="processing">{{text}}</a-tag>

                    </template>
                    <template v-else-if="column.key === 'maxOrderNum'" >
                        <a-tag color="processing">{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'intervalTime'" >
                        <a-tag color="processing">{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'action'" >
                        <a-button @click="setConfig(record)" type="dashed" shape="circle">
                            <template #icon><edit-outlined /></template>
                        </a-button>
                    </template>
                    <template v-else-if="column.key === 'chaqi'">
                        <a-switch @change="chaqiAction(record)" v-model:checked="record.IsChaQi" checked-children="是" un-checked-children="否" />
                        <a-button v-if="record.IsChaQi" size="small" style="margin-left:8px" @click="testAction(record)">测试</a-button>
                    </template>
                    <template v-else-if="column.key === 'shopType'" >
                        <a-tag color="#2db7f5" v-if="text==1">淘宝</a-tag>
                        <a-tag color="#2db7f5" v-else-if="text==2">京东</a-tag>
                        <a-tag color="#2db7f5" v-else-if="text==3">拼多多</a-tag>
                        <a-tag color="#2db7f5" v-else-if="text==5">阿里巴巴</a-tag>
                        <a-tag color="#2db7f5" v-else>抖音</a-tag>
                    </template>
                </template>
                
            </a-table>
        </div>

        <a-modal :confirmLoading="testing" v-model:visible="testVisible" title="插旗测试" @ok="testOk" style="width:420px" ok-text="发起测试" cancel-text="关闭">
            <div>
                <p style="color:#8c8c8c;font-size:12px;line-height:1.6;margin-bottom:12px">
                    用该店铺已保存的旺旺号和密码，对下面填写的订单号真实发起一次插旗（只发一次，不重试）。
                </p>
                <p style="margin-bottom:8px">
                    店铺：<b>{{ testShopName }}</b>
                </p>
                <a-input v-model:value="testOrderCode" placeholder="请输入该店铺的订单号" allow-clear />
                <a-alert v-if="testResult" style="margin-top:12px" :type="testOk2 ? 'success' : 'error'" :message="testResult" />
            </div>
        </a-modal>

        <a-modal :confirmLoading="chaqiOperateing" v-model:visible="chaqiVisible" title="自动插旗" @ok="chaqiOk" @cancel="chaqiCancel" style="width:360px" ok-text="确认" cancel-text="取消">
            <div>
                <a-form
                    :model="chaqiModel"
                    name="chaqiForm"
                    ref="chaqiForm"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 18 }"
                    autocomplete="off"
                >
                    <a-form-item label="店铺旺旺" name="sellerWang" :rules="[{ required: true, message: '请填写店铺旺旺' }]">
                        <a-input v-model:value="chaqiModel.sellerWang" />
                    </a-form-item>
                    <a-form-item label="店铺密码" name="passWord" :rules="[{ required: true, message: '请填写店铺密码' }]">
                        <a-input v-model:value="chaqiModel.passWord" />
                    </a-form-item>
                    <a-form-item label="镖旗颜色" name="color" :rules="[{ required: true, message: '请选择镖旗颜色' }]">
                        <a-select v-model:value="chaqiModel.color" style="width: 120px">
                            <a-select-option :value="1">红色</a-select-option>
                            <a-select-option :value="2">黄色</a-select-option>
                            <a-select-option :value="3">绿色</a-select-option>
                            <a-select-option :value="4">蓝色</a-select-option>
                            <a-select-option :value="5">紫色</a-select-option>
                            <a-select-option :value="6">橙色</a-select-option>
                            <a-select-option :value="7">浅蓝</a-select-option>
                            <a-select-option :value="8">浅粉</a-select-option>
                            <a-select-option :value="9">深绿</a-select-option>
                            <a-select-option :value="10">桃红</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="插旗备注" name="remark" :rules="[{ required: true, message: '请填写插旗备注' }]">
                        <a-input v-model:value="chaqiModel.remark" />
                    </a-form-item>
                </a-form>
            </div>
        </a-modal>

        <a-modal :confirmLoading="operateing" v-model:visible="visible" title="店铺配置" @ok="ok" style="width:300px" ok-text="确认" cancel-text="取消">
            <div style="text-align:center">
                <p>
                    <a-input-number style="width:180px" v-model:value="config.IntervalTime" addon-before="放单间隔" ></a-input-number>
                </p>
                <p>
                    <a-input-number style="width:180px" v-model:value="config.Repurchase" addon-before="复购天数" ></a-input-number>
                </p>
                <p>
                    <a-input-number style="width:180px" v-model:value="config.PraiseDay" addon-before="好评天数"></a-input-number>
                </p>
                <p>
                    <a-input-number style="width:180px" v-model:value="config.MaxOrderNum" addon-before="最大单量" ></a-input-number>
                </p>
            </div>
        </a-modal>
    </div>
</template>
<script>
import {  ref } from 'vue';
import { shopGetReq ,shopSetShopConfigReq,shopSetChaQiReq,shopTestChaQiReq} from '@/request.js';


// import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { SearchOutlined,EditOutlined} from '@ant-design/icons-vue';

export default {
    components: {
        SearchOutlined,EditOutlined
    },
    setup(){
        const operateing=ref(false);
        const config=ref({
            MaxOrderNum:0,
            PraiseDay:0,
            Repurchase:0,
            IntervalTime:0,
        })
        const tableHeight=ref(0);
        tableHeight.value=document.documentElement.clientHeight-260;
        const setRow=ref({});
        const visible=ref(false);
        const loading=ref(false);
        const pagination=ref({
            total: 0,
            pageSize: 20,
            showSizeChanger: false,
            showTotal: total => `共 ${total} 条`,  
        });
        const list=ref([]);
        const queryParam=ref({
            queryTxt:"",
        })
        const ok=()=>{
            operateing.value=true;
            shopSetShopConfigReq({
                Id:setRow.value.Id,
                Repurchase:config.value.Repurchase,
                MaxOrderNum:config.value.MaxOrderNum,
                PraiseDay:config.value.PraiseDay,
                IntervalTime:config.value.IntervalTime,
            },(res)=>{
                if(res.IsSuccess){
                    setRow.value.Repurchase=config.value.Repurchase;
                    setRow.value.MaxOrderNum=config.value.MaxOrderNum;
                    setRow.value.PraiseDay=config.value.PraiseDay;
                    setRow.value.IntervalTime=config.value.IntervalTime;
                    visible.value=false;
                    message.success("设置成功");
                }else{
                    message.error(res.Message);
                }
                operateing.value=false;
            })
        };
        const setConfig=(record)=>{
            config.value.Repurchase=record.Repurchase;
            config.value.MaxOrderNum=record.MaxOrderNum;
            config.value.PraiseDay=record.PraiseDay;
            config.value.IntervalTime=record.IntervalTime;
            visible.value=true;
            setRow.value=record;
        }
        const query=(index)=>{
            loading.value=true;
            shopGetReq({
                pIndex:index,
                pSize:pagination.value.pageSize,
                queryTxt:queryParam.value.queryTxt,
                type:!queryParam.value.type?0:parseInt(queryParam.value.type)
            },(res)=>{
                list.value=res.Result;
                pagination.value.total=res.TotalCount;
                loading.value=false;
            })
        };
        const handleTableChange=(e)=>{
            query(e.current);
        };
        query(1);
        // ===== 插旗测试 =====
        const testVisible=ref(false);
        const testing=ref(false);
        const testOrderCode=ref("");
        const testShopName=ref("");
        const testShopId=ref(0);
        const testResult=ref("");
        const testOk2=ref(false);

        const testAction=(record)=>{
            testShopId.value=record.Id;
            testShopName.value=record.Name;
            testOrderCode.value="";
            testResult.value="";
            testVisible.value=true;
        }
        const testOk=()=>{
            if(!testOrderCode.value){
                message.warning("请填写订单号");
                return;
            }
            testing.value=true;
            testResult.value="";
            shopTestChaQiReq({ id:testShopId.value, orderCode:testOrderCode.value },(res)=>{
                testOk2.value=!!res.IsSuccess;
                testResult.value=res.Message||(res.IsSuccess?"插旗成功":"插旗失败");
                testing.value=false;
            })
        }

        // ===== 自动插旗 =====
        const chaqiVisible=ref(false);
        const chaqiOperateing=ref(false);
        const chaqiForm=ref();
        const chaqiRow=ref();
        const chaqiModel=ref({ id:0, sellerWang:"", passWord:"", color:5, remark:"" });

        const chaqiAction=(record)=>{
            chaqiRow.value=record;
            if(record.IsChaQi){
                // 打开：带出已有配置让人确认/修改
                chaqiModel.value={
                    id:record.Id,
                    sellerWang:record.SellerWang||"",
                    passWord:record.PassWord||"",
                    color:record.Color||5,
                    remark:record.ChaQiRemark||""
                };
                chaqiVisible.value=true;
            }else{
                // 关闭：清空旺旺号和密码即为停用
                shopSetChaQiReq({ id:record.Id, sellerWang:"", passWord:"", color:0, remark:"" },(res)=>{
                    if(res.IsSuccess){
                        message.success("已关闭自动插旗");
                    }else{
                        message.error(res.Message||"操作失败");
                        record.IsChaQi=true;
                    }
                })
            }
        }
        const chaqiCancel=()=>{
            if(chaqiRow.value){ chaqiRow.value.IsChaQi=false; }
        }
        const chaqiOk=()=>{
            chaqiForm.value
            .validate()
            .then(()=>{
                chaqiOperateing.value=true;
                shopSetChaQiReq(chaqiModel.value,(res)=>{
                    if(res.IsSuccess){
                        chaqiVisible.value=false;
                        message.success("保存成功");
                        query(pagination.value.current);
                    }else{
                        message.error(res.Message||"保存失败");
                    }
                    chaqiOperateing.value=false;
                })
            })
            .catch(()=>{});
        }

        return{
            testVisible,
            testing,
            testOrderCode,
            testShopName,
            testResult,
            testOk2,
            testAction,
            testOk,
            chaqiVisible,
            chaqiOperateing,
            chaqiForm,
            chaqiModel,
            chaqiAction,
            chaqiOk,
            chaqiCancel,
            operateing,
            config,
            setConfig,
            ok,
            tableHeight,
            visible,
            loading,
            handleTableChange,
            queryParam,
            list,
            query,
            pagination,
            columns: [
                {
                    title: '店铺名',
                    dataIndex: 'Name',
                    key: 'name',
                },
                {
                    title: '店铺类型',
                    dataIndex: 'Type',
                    key: 'shopType',
                },
                {
                    title: '商家名称',
                    dataIndex: 'MemberName',
                    key: 'memberName',
                },
                {
                    title: '商家账号',
                    dataIndex: 'MemberPhone',
                    key: 'memberPhone',
                },
                {
                    title: '创建时间',
                    dataIndex: 'CreateTime',
                    key: 'createTime',
                },
                {
                    title: '放单间隔',
                    dataIndex: 'IntervalTime',
                    key: 'intervalTime',
                },
                {
                    title: '复购天数',
                    dataIndex: 'Repurchase',
                    key: 'repurchase',
                },
                {
                    title: '好评天数',
                    dataIndex: 'PraiseDay',
                    key: 'praiseDay',
                },
                {
                    title: '日最大单量',
                    dataIndex: 'MaxOrderNum',
                    key: 'maxOrderNum',
                },
                {
                    title: '自动插旗',
                    dataIndex: 'IsChaQi',
                    key: 'chaqi',
                    width: 100,
                },
                {
                    title: '操作',
                    key: 'action',
                },
            ],
        }
    }
}
</script>
<style scoped>
.remark{
    text-overflow:ellipsis;white-space:nowrap; overflow:hidden;width:100px;cursor:pointer
}
</style>